import { useApiFetch } from '../api';

export function useDeployment(
  workspaceId: number,
  fleetId: number,
  deploymentId: number,
  options?: { shouldFetch?: boolean }
) {
  const shouldFetch = options?.shouldFetch ?? true;
  return useApiFetch(
    shouldFetch ? `workspaces/${workspaceId}/fleets/${fleetId}/deployments/${deploymentId}` : null,
    async (callApi) =>
      await callApi((api) =>
        api.fleets.getV1WorkspacesWorkspaceidFleetsFleetidDeploymentsDeploymentid({
          workspaceId,
          fleetId,
          deploymentId,
        })
      )
  );
}
